"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _ChevronRightRounded = _interopRequireDefault(require("@mui/icons-material/ChevronRightRounded"));
var _MenuItem = _interopRequireDefault(require("@mui/material/MenuItem/MenuItem.js"));
var _ListItemIcon = _interopRequireDefault(require("@mui/material/ListItemIcon/ListItemIcon.js"));
var _ListItemText = _interopRequireDefault(require("@mui/material/ListItemText/ListItemText.js"));
var _Popper = _interopRequireDefault(require("@mui/material/Popper/Popper.js"));
var _makeStyles = _interopRequireDefault(require("@mui/styles/makeStyles"));
var _hooks = require("../hooks");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const useStyles = (0, _makeStyles.default)(({
  palette,
  spacing
}) => {
  const topBarColor = palette.background.topBar || '';
  const topBarContrast = palette.getContrastText(topBarColor);
  return {
    item: {
      padding: spacing(0.5, 1.5)
    },
    itemIcon: {
      width: 24,
      justifyContent: 'center',
      '& svg': {
        color: topBarContrast
      }
    },
    optionText: {
      color: topBarContrast
    },
    hoveredItem: {
      backgroundColor: 'rgba(0, 0, 0, 0.08)'
    }
  };
});
const delay = 100;
let timeoutId;
var _default = exports.default = /*#__PURE__*/(0, _react.forwardRef)(function MenuItem({
  item,
  closeMenu
}, ref) {
  const classes = useStyles({});
  const internalRef = (0, _react.useRef)(null);
  const itemRef = ref || internalRef;
  let isHovered = (0, _hooks.useHover)(internalRef);
  const [open, setOpen] = (0, _react.useState)(false);
  const {
    Component,
    click,
    name,
    icon
  } = item;
  (0, _react.useEffect)(() => {
    if (Component) {
      if (isHovered) {
        clearTimeout(timeoutId);
        setOpen(true);
      } else {
        timeoutId = setTimeout(() => setOpen(false), delay);
      }
    }
  }, [isHovered]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    ref: itemRef,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_MenuItem.default, {
      dense: true,
      onClick: e => {
        if (!Component && click) {
          click();
          closeMenu(e);
        }
      },
      className: (0, _classnames.default)(classes.item, {
        [classes.hoveredItem]: open
      }),
      children: [icon && /*#__PURE__*/(0, _jsxRuntime.jsx)(_ListItemIcon.default, {
        className: classes.itemIcon,
        children: icon
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_ListItemText.default, {
        classes: {
          primary: classes.optionText
        },
        children: name
      }), Component && /*#__PURE__*/(0, _jsxRuntime.jsx)(_ListItemIcon.default, {
        className: classes.itemIcon,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_ChevronRightRounded.default, {})
      })]
    }), Component && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Popper.default, {
      open: open,
      anchorEl: itemRef.current,
      placement: "right-start",
      disablePortal: true,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(Component, {})
    })]
  });
});